module.exports = __webpack_public_path__ + "static/media/hoisting-reference-error.e57df0c8.png";